<template>
  <v-form-create v-if="access_role.create_access" name="role" without-title>
    <v-form v-model="is_valid">
      <v-card-text>
        <v-text-field
          :label="$t('name')"
          v-model="name"
          :readonly="is_boss"
          ref="name"
          :rules="[fieldRules.required]"
        />
      </v-card-text>
    </v-form>
    <v-list>
      <v-list-item three-line>
        <v-list-item-avatar color="success">
          <v-icon dark>mdi-tablet-cellphone</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>POS</v-list-item-title>
          <v-list-item-subtitle>{{
            $t("employees_can_log_in_to_the_app_using_personal_PIN_code")
          }}</v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action>
          <v-switch
            v-model="access.pos.access"
            color="success"
            :disabled="is_boss"
          />
        </v-list-item-action>
      </v-list-item>
    </v-list>
    <v-expand-transition v-if="access.pos.access">
      <v-card-text>
        <v-checkbox
          color="success"
          v-for="(access, access_index) in access.pos.roles"
          :key="access_index"
          hide-details
          :label="$t(access.title)"
          v-model="access.value"
          v-bind="access.bind ? access.bind : {}"
          :disabled="is_boss || it_self"
        />
      </v-card-text>
    </v-expand-transition>

    <v-list :disabled="is_boss || it_self">
      <v-list-item three-line>
        <v-list-item-avatar color="success">
          <v-icon dark>mdi-tablet-cellphone</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{ $t("back_office") }}</v-list-item-title>
          <v-list-item-subtitle>{{
            $t(
              "employees_can_log_in_to_the_back_office_using_their_email_and_password"
            )
          }}</v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action>
          <v-switch
            v-model="access.back_office.access"
            color="success"
            :disabled="is_boss || it_self"
          />
        </v-list-item-action>
      </v-list-item>
    </v-list>
    <v-expand-transition v-if="access.back_office.access">
      <v-card-text>
        <v-checkbox
          color="success"
          v-for="(access, access_index) in access.back_office.roles"
          :key="access_index"
          hide-details
          :label="$t(access.title)"
          v-model="access.value"
          v-bind="access.bind ? access.bind : {}"
          :disabled="is_boss || it_self"
        />
      </v-card-text>
    </v-expand-transition>

    <!-- <v-list v-if="access.back_office.access">
      <v-list-item three-line>
        <v-list-item-avatar color="success">
          <v-icon dark>mdi-account-multiple</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{ $t("workgroup") }}</v-list-item-title>
          <v-list-item-subtitle>{{
            $t("employees_can_use_workgroup")
          }}</v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action>
          <v-switch
            v-model="access.workgroup.access"
            color="success"
            :disabled="is_boss || it_self"
          />
        </v-list-item-action>
      </v-list-item>
    </v-list>
    <v-expand-transition
      v-if="access.workgroup.access && access.back_office.access"
    >
      <v-card-text>
        <v-checkbox
          color="success"
          v-for="(access, access_index) in access.workgroup.roles"
          v-bind:key="access_index"
          hide-details
          v-bind:label="$t(access.title)"
          v-model="access.value"
          v-bind="access.bind ? access.bind : {}"
          :disabled="is_boss || it_self"
        />
      </v-card-text>
    </v-expand-transition> -->

    <v-list v-if="access.back_office.access">
      <v-list-item three-line>
        <v-list-item-avatar color="success">
          <v-icon dark>mdi-chart-bar</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{ $t("reports") }}</v-list-item-title>
          <v-list-item-subtitle>{{
            $t("employees_can_use_reports")
          }}</v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action>
          <v-switch
            v-model="access.reports.access"
            color="success"
            :disabled="is_boss || it_self"
          />
        </v-list-item-action>
      </v-list-item>
    </v-list>
    <v-expand-transition
      v-if="access.reports.access && access.back_office.access"
    >
      <v-card-text>
        <v-checkbox
          color="success"
          v-for="(access, access_index) in access.reports.roles"
          :key="access_index"
          hide-details
          v-bind:label="$t(access.title)"
          v-model="access.value"
          v-bind="access.bind ? access.bind : {}"
          :disabled="is_boss || it_self"
        />
      </v-card-text>
    </v-expand-transition>

    <v-list v-if="access.back_office.access">
      <v-list-item three-line>
        <v-list-item-avatar color="success">
          <v-icon dark>mdi-basket</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{ $t("items") }}</v-list-item-title>
          <v-list-item-subtitle>{{
            $t("employees_can_use_items")
          }}</v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action>
          <v-switch
            v-model="access.items.access"
            color="success"
            :disabled="is_boss || it_self"
          />
        </v-list-item-action>
      </v-list-item>
    </v-list>
    <v-expand-transition
      v-if="access.items.access && access.back_office.access"
    >
      <v-card-text>
        <v-checkbox
          color="success"
          v-for="(access, access_index) in access.items.roles"
          v-bind:key="access_index"
          hide-details
          v-bind:label="$t(access.title)"
          v-model="access.value"
          v-bind="access.bind ? access.bind : {}"
          :disabled="is_boss || it_self"
        />
      </v-card-text>
    </v-expand-transition>
    <v-list v-if="access.back_office.access">
      <v-list-item three-line>
        <v-list-item-avatar color="success">
          <v-icon dark>mdi-cart</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{ $t("inventory") }}</v-list-item-title>
          <v-list-item-subtitle>{{
            $t("employees_can_use_inventory")
          }}</v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action>
          <v-switch
            v-model="access.inventory.access"
            color="success"
            :disabled="is_boss || it_self"
          />
        </v-list-item-action>
      </v-list-item>
    </v-list>
    <v-expand-transition
      v-if="access.inventory.access && access.back_office.access"
    >
      <v-card-text>
        <v-checkbox
          color="success"
          v-for="(access, access_index) in access.inventory.roles"
          v-bind:key="access_index"
          hide-details
          v-bind:label="$t(access.title)"
          v-model="access.value"
          v-bind="access.bind ? access.bind : {}"
          :disabled="is_boss || it_self"
        />
      </v-card-text>
    </v-expand-transition>
    <v-list v-if="access.back_office.access">
      <v-list-item three-line>
        <v-list-item-avatar color="success">
          <v-icon dark>mdi-account-card-details</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{ $t("employees") }}</v-list-item-title>
          <v-list-item-subtitle>{{
            $t("can_use_employees")
          }}</v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action>
          <v-switch
            v-model="access.employees.access"
            color="success"
            :disabled="is_boss || it_self"
          />
        </v-list-item-action>
      </v-list-item>
    </v-list>
    <v-expand-transition
      v-if="access.employees.access && access.back_office.access"
    >
      <v-card-text>
        <v-checkbox
          color="success"
          v-for="(access, access_index) in access.employees.roles"
          v-bind:key="access_index"
          hide-details
          v-bind:label="$t(access.title)"
          v-model="access.value"
          v-bind="access.bind ? access.bind : {}"
          :disabled="is_boss || it_self"
        />
      </v-card-text>
    </v-expand-transition>

    <v-list v-if="access.back_office.access">
      <v-list-item three-line>
        <v-list-item-avatar color="success">
          <v-icon dark>mdi-account-multiple</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{ $t("customers") }}</v-list-item-title>
          <v-list-item-subtitle>{{
            $t("employees_can_use_customers")
          }}</v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action>
          <v-switch
            v-model="access.customers.access"
            color="success"
            :disabled="is_boss || it_self"
          />
        </v-list-item-action>
      </v-list-item>
    </v-list>
    <!-- <v-expand-transition
      v-if="access.customers.access && access.back_office.access"
    >
      <v-card-text>
        <v-checkbox
          color="success"
          v-for="(access, access_index) in access.customers.roles"
          v-bind:key="access_index"
          hide-details
          v-bind:label="$t(access.title)"
          v-model="access.value"
          v-bind="access.bind ? access.bind : {}"
          :disabled="is_boss || it_self"
        />
      </v-card-text>
    </v-expand-transition> -->

    <v-list v-if="access.back_office.access">
      <v-list-item three-line>
        <v-list-item-avatar color="success">
          <v-icon dark>mdi-settings</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{ $t("settings") }}</v-list-item-title>
          <v-list-item-subtitle>{{
            $t("employees_can_use_settings")
          }}</v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action>
          <v-switch
            v-model="access.settings.access"
            color="success"
            :disabled="is_boss || it_self"
          />
        </v-list-item-action>
      </v-list-item>
    </v-list>
    <v-expand-transition
      v-if="access.settings.access && access.back_office.access"
    >
      <v-card-text>
        <v-checkbox
          color="success"
          v-for="(access, access_index) in access.settings.roles"
          v-bind:key="access_index"
          hide-details
          v-bind:label="$t(access.title)"
          v-model="access.value"
          v-bind="access.bind ? access.bind : {}"
          :disabled="is_boss || it_self"
        />
      </v-card-text>
    </v-expand-transition>

    <v-list v-if="access.back_office.access">
      <v-list-item three-line>
        <v-list-item-avatar color="success">
          <v-icon dark>mdi-playlist-plus</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{ $t("create") }}</v-list-item-title>
          <v-list-item-subtitle>{{
            $t("employees_can_use_create")
          }}</v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action>
          <v-switch
            v-model="access.create.access"
            color="success"
            :disabled="is_boss || it_self"
          />
        </v-list-item-action>
      </v-list-item>
    </v-list>
    <v-expand-transition
      v-if="access.create.access && access.back_office.access"
    >
      <v-card-text>
        <v-checkbox
          color="success"
          v-for="(access, access_index) in access.create.roles"
          v-bind:key="access_index"
          hide-details
          v-bind:label="$t(access.title)"
          v-model="access.value"
          v-bind="access.bind ? access.bind : {}"
          :disabled="is_boss || it_self"
        />
      </v-card-text>
    </v-expand-transition>

    <template #action>
      <v-btn text @click="cancelClicked">{{ $t("cancel") }}</v-btn>
      <v-btn
        text
        color="primary"
        :loading="loading_role"
        :disabled="saveDisabled"
        v-on:click="save"
        >{{ $t("save") }}</v-btn
      >
    </template>
  </v-form-create>
  <error404 v-else></error404>
</template>
<script>
const access = {
  pos: {
    access: false,
    roles: [
      { name: "close_ticket", title: "close_ticket", value: false },
      { name: "can_sell", title: "can_sell", value: false },
      { name: "print_pre_check", title: "print_pre_check", value: false },
      { name: "refund", title: "refund", value: false },
      // {
      //   name: "receipt_save_as_draft",
      //   title: "receipt_save_as_draft",
      //   value: false,
      // },
      { name: "can_change_price", title: "can_change_price", value: false },
      { name: "show_all_receipts", title: "show_all_receipts", value: false },
      // { name: "pay_debt", title: "pay_debt", value: false },
      { name: "show_shift_history", title: "show_shift_history", value: false },
      { name: "apply_discount", title: "apply_discount", value: false },
      { name: "change_settings", title: "change_settings", value: false },
      { name: "edit_items", title: "edit_items", value: false },
      // { name: "edit_ticket", title: "edit_ticket", value: false },
      // { name: "split_ticket", title: "split_check", value: false },
      // { name: "change_waiter", title: "change_waiter", value: false },
      // { name: "change_ticket", title: "change_ticket", value: false },
      { name: "delete_ticket", title: "delete_ticket", value: false },
      // { name: "show_all_tickets", title: "show_all_tickets", value: false },
      {
        name: "can_access_to_shift",
        title: "can_access_to_shift",
        value: false,
      },
      // { name: "wharehouse_manager", title: "wharehouse_manager", value: false },
    ],
  },
  back_office: {
    access: false,
    roles: [
      // { name: "reports", title: "reports", value: false },
      // { name: "items", title: "items", value: false },
      // { name: "employees", title: "employees", value: false },
      // { name: "customers", title: "customers", value: false },
      // { name: "settings", title: "settings", value: false },
      { name: "edit_profile", title: "edit_profile", value: false },
      { name: "item_mark_edit", title: "item_mark_edit", value: false },
      { name: "item_edit", title: "item_edit", value: false },
      { name: "set_the_taxes", title: "set_the_taxes", value: false },
      { name: "manage_pos_devices", title: "manage_pos_devices", value: false },
      { name: "can_delete_item", title: "can_delete_item", value: false },
    ],
  },
  inventory: {
    access: false,
    roles: [
      { name: "inv_purchase_orders", title: "purchase_orders", value: false },
      {
        name: "inv_purchase_orders_cost",
        title: "purchase_orders_cost",
        value: false,
      },
      { name: "inv_purchase_mark", title: "purchase_mark", value: false },
      { name: "inv_transfer_orders", title: "transfer_orders", value: false },
      { name: "inv_stock_adjusment", title: "stock_adjusment", value: false },
      {
        name: "inv_stock_adjusment_cost",
        title: "stock_adjusment_cost",
        value: false,
      },
      { name: "inv_inventory_counts", title: "inventory_counts", value: false },
      { name: "inv_productions", title: "productions", value: false },
      { name: "inv_productions_cost", title: "productions_cost", value: false },
      { name: "inv_suppliers", title: "suppliers", value: false },
      {
        name: "inv_supplier_transaction",
        title: "supplier_transaction",
        value: false,
      },
      {
        name: "inv_supplier_transaction_corrector",
        title: "supplier_transaction_corrector",
        value: false,
      },
      { name: "inv_fees", title: "fees", value: false },
      {
        name: "inv_inventory_history",
        title: "inventory_history",
        value: false,
      },
      {
        name: "inv_inventory_valuation",
        title: "inventory_valuation",
        value: false,
      },
      {
        name: "inv_supplier_valuation",
        title: "supplier_valuation",
        value: false,
      },
    ],
  },

  reports: {
    access: false,
    roles: [
      { name: "report_sale", title: "sale_summary", value: false },
      { name: "material_report", title: "material_report", value: false },
      { name: "report_accaunt", title: "accaunt", value: false },
      // { name: "report_abs", title: "abs", value: false },
      { name: "report_sale_by_item", title: "sale_by_item", value: false },
      {
        name: "report_sale_by_category",
        title: "sale_by_category",
        value: false,
      },
      {
        name: "report_sale_by_supplier",
        title: "sale_by_supplier",
        value: false,
      },
      { name: "report_employee", title: "employee", value: false },
      {
        name: "report_sale_by_payment",
        title: "sale_by_payment",
        value: false,
      },
      { name: "report_receipt", title: "receipt", value: false },
      { name: "report_debt", title: "debt", value: false },
      { name: "report_discount", title: "discount", value: false },
      { name: "report_taxes", title: "taxes", value: false },
      { name: "report_shift", title: "shift", value: false },
    ],
  },

  items: {
    access: false,
    roles: [
      { name: "item_list", title: "list", value: false },
      { name: "item_mxik_search", title: "mxik_search", value: false },
      { name: "item_composite_item", title: "composite_item", value: false },
      {
        name: "item_add_from_warehause",
        title: "add_from_warehause",
        value: false,
      },
      { name: "item_print_label", title: "print_label", value: false },
      { name: "item_mark", title: "item_mark", value: false },
      {
        name: "item_price_change_history",
        title: "price_change_history",
        value: false,
      },
      { name: "item_categories", title: "categories", value: false },
      { name: "item_modifiers", title: "modifiers", value: false },
      { name: "item_discount", title: "discount", value: false },
    ],
  },
  settings: {
    access: false,
    roles: [
      { name: "setting_general", title: "general", value: false },
      { name: "setting_organization", title: "organization", value: false },
      { name: "setting_nds", title: "nds", value: false },
      { name: "setting_payment_types", title: "payment_types", value: false },
      { name: "setting_currency", title: "currency", value: false },
      { name: "setting_loyalty", title: "loyalty", value: false },
      { name: "setting_taxes", title: "taxes", value: false },
      { name: "setting_receipt", title: "receipt", value: false },
      // { name: "setting_open_tickets", title: "open_tickets", value: false },
      // { name: "setting_buttons", title: "buttons", value: false },
      // { name: "setting_options", title: "options", value: false },
      { name: "setting_stores", title: "stores", value: false },
      { name: "setting_pos_devices", title: "pos_devices", value: false },
    ],
  },

  employees: {
    access: false,
    roles: [
      { name: "employee_list", title: "employee_list", value: false },
      { name: "employee_access_rights", title: "access_rights", value: false },
      { name: "employee_time_cards", title: "time_cards", value: false },
      {
        name: "employee_total_worked",
        title: "total_worked",
        value: false,
      },
    ],
  },

  workgroup: {
    access: false,
    roles: [
      {
        name: "workgroup_edit_cost",
        title: "workgroup_edit_cost",
        value: false,
      },
    ],
  },
  customers: { access: false },
  create: {
    access: false,
    roles: [
      { name: "create_purchase", title: "create_purchase", value: false },
      { name: "create_mark", title: "create_purchase_mark", value: false },
      { name: "create_taxes", title: "create_taxes", value: false },
      { name: "create_store", title: "create_store", value: false },
      { name: "create_pos_device", title: "create_pos_device", value: false },
      { name: "create_customer", title: "create_customer", value: false },
      { name: "create_employee", title: "create_employee", value: false },
      { name: "create_access", title: "create_access", value: false },
      { name: "create_time_card", title: "create_time_card", value: false },
      { name: "create_transfer", title: "create_transfer", value: false },
      {
        name: "create_stock_adjustmen",
        title: "create_stock_adjustmen",
        value: false,
      },
      { name: "create_inv_count", title: "create_inv_count", value: false },
      { name: "create_production", title: "create_production", value: false },
      { name: "create_supplier", title: "create_supplier", value: false },
      {
        name: "create_supplier_create_doc",
        title: "create_supplier_create_doc",
        value: false,
      },
      { name: "create_fee", title: "create_fee", value: false },
      { name: "create_good_sale", title: "create_good_sale", value: false },
      {
        name: "create_good_category",
        title: "create_good_category",
        value: false,
      },
      { name: "create_modifier", title: "create_modifier", value: false },
      { name: "create_discount", title: "create_discount", value: false },
      { name: "create_reciept", title: "create_reciept", value: false },
    ],
  },
};
import Userable from "../../mixins/userable";
export default {
  data: () => ({
    name: null,
    access,
    access_role: null,
    is_valid: false,
    is_boss: false,
    it_self: false,
    loading_role: false,
  }),
  mixins: [Userable],
  computed: {
    form() {
      return {
        name: this.name,
      };
    },
    saveDisabled() {
      let formHasErrors = false || !this.is_valid;
      Object.keys(this.form).forEach((f) => {
        if (!this.form[f]) formHasErrors = true;
      });
      return formHasErrors;
    },
  },
  methods: {
    cancelClicked() {
      this.$router.push("/employees/access").catch(() => {});
    },
    async save() {
      this.loading_role = true;
      let access = {
        name: this.name,
        pos: this.access.pos.access,
        back_office: this.access.back_office.access,
        inventory: this.access.inventory.access,
        workgroup: this.access.workgroup.access,
        reports: this.access.reports.access,
        items: this.access.items.access,
        settings: this.access.settings.access,
        employees: this.access.employees.access,
        customers: this.access.customers.access,
        create: this.access.create.access,
      };
      for (const ind in [
        "pos",
        "back_office",
        "inventory",
        "workgroup",
        "reports",
        "items",
        "settings",
        "employees",
        "customers",
        "create",
      ]) {
        const name = Object.keys(this.access)[ind];
        if (this.access[name] && this.access[name].roles instanceof Array) {
          for (const index in this.access[name].roles) {
            access[this.access[name].roles[index].name] =
              this.access[name].roles[index].value &&
              (ind == 2
                ? access["inventory"]
                : ind == 1
                ? access["back_office"]
                : true);
          }
        }
      }
      if (this.$route.params["target"] == "update") {
        await this.$communicator("update_access", {
          arguments: [this.$route.query["id"]],
          params: access,
        });
        this.$toast.success("Success", { timeout: 2000 });
      } else {
        await this.$communicator("create_access", {
          params: access,
        });
        this.$toast.success("Success", { timeout: 2000 });
      }
      this.$router.push({ path: "/employees/access" });
      this.loading_role = false;
    },
    async update() {
      const access = this.$communicator.then(
        this,
        await this.$communicator("access", {
          arguments: [this.$route.query["id"]],
        })
      );
      this.name = access["name"];
      if (this.name == "boss") {
        this.is_boss = true;
      }

      if (this.user_access && this.user_access.name == this.name) {
        this.it_self = true;
      }
      for (const index in [
        "pos",
        "back_office",
        "inventory",
        "workgroup",
        "reports",
        "items",
        "settings",
        "employees",
        "customers",
        "create",
      ]) {
        const name = Object.keys(this.access)[index];
        this.access[name].access = access[name] || this.is_boss;
        if (this.access[name] && this.access[name].roles instanceof Array) {
          for (const index in this.access[name].roles) {
            this.access[name].roles[index].value =
              access[this.access[name].roles[index].name] || this.is_boss;
          }
        }
      }
    },
  },
  mounted() {
    if (this.$route.params["target"] == "update") {
      this.update();
    } else {
      this.access = this.$copy(access);
    }
  },
  beforeMount() {
    this.access_role = this.$store.state.access;
  },
};
</script>
